import { render } from "./SubscribeNow.vue?vue&type=template&id=b94c9038"
import script from "./SubscribeNow.vue?vue&type=script&lang=js"
export * from "./SubscribeNow.vue?vue&type=script&lang=js"
script.render = render

export default script